const strings = {
  'quiz/sectionTitle/faceOff/text': {
    en: 'The Face Off',
    fr: 'La mise au jeu',
  },
  'quiz/helpInfo/text': {
    en: 'Please solve the math problem below to continue',
    fr: 'Veuillez répondre correctement à la question d’habileté suivante pour continuer',
  },
  'quiz/question/multiply/text': {
    en: `Multiply by`,
    fr: `Multipliez par`,
  },
  'quiz/question/divideBy/text': {
    en: `Divide by`,
    fr: `Divisez par`,
  },
  'quiz/question/add/text': {
    en: `Add`,
    fr: `Additionnez`,
  },
  'quiz/question/subtract/text': {
    en: `Subtract`,
    fr: `Soustrayez`,
  },
  'quiz/answerTitle/text': {
    en: 'Select the correct answer',
    fr: 'Sélectionnez la bonne réponse',
  },
  'quiz/failedTitle/text': {
    en: 'Better luck next time',
    fr: 'Meilleure chance la prochaine fois',
  },
  'quiz/failedInfo/text': {
    en: `Looks like your answers missed the net and you weren’t able to provide the
      correct answer.`,
    fr: `Vos réponses semblent avoir raté le filet. Vous n’avez pas correctement répondu à la question d’habilité.`,
  },
};

export default strings;
